import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import CargoComponent from '../../components/CargoComponent';
import InputText from '../../components/Forms/InputText';
import MultiSelect from '../../components/MultiSelect';
import PageLoaderComponent from '../../components/PageLoader';
import RoleSelectorComponent from '../../components/RoleSelectorComponent';
import SpeciesComponentTabs from '../../components/SpeciesComponentTabs';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import Template from '../../template';
import { MaskDocument, MaskPhone } from '../../utils/mask';
import * as S from './style';

// Component

export default function AddNewUser (props) {
  const { doLogout } = useAuth();
  const [user, setUser] = useState({
    species: [],
    parentList: []
  });
  const [distributor, setDistributor] = useState({});
  const [hasDistributor, setHasDistributor] = useState(false);
  const [errors, setErrors] = useState({})
  const [button, setButton] = useState({
    name: 'Carregando dados',
    isDisabled: true
  });

  const handleUserCreate = useCallback(async (e) => {
    e.preventDefault();
    setButton({
      name: 'Salvando dados',
      isDisabled: true
    });

    try {
      await api.post('/user', { ...user });
      toast.success('Os dados foram salvos', { theme: 'colored' });
    } catch (e) {
      if (!e.response.data.message) {
        toast.error('Ocorreu um erro, por favor tente novamente mais tarde', { theme: 'colored' });
        return;
      }

      if (e.response.data.message === 'Token inválido') {
        doLogout();
        toast.error(e.response.data.message, { theme: 'colored' });
        return;
      }

      toast.error(e.response.data.message, { theme: 'colored' });
    }
    setButton({
      name: 'Salvar dados',
      isDisabled: false
    });
  }, [doLogout, user]);

  const handleRoleChange = useCallback((role) => {
    setUser({ ...user, roleId: role.id });
    setHasDistributor(!!role.distributor);
  }, [user]);

  const handleSpeciesChange = useCallback((species) => {
    setUser(user => ({ ...user, species }))
  }, [])

  const handleSetErrors = useCallback((val) => {
    setErrors((errors) => ({ ...errors, speciesComponentTabs: val }))
  }, [])

  useEffect(() => {
    setButton({
      name: 'Salvar dados',
      isDisabled: false
    });
  }, []);

  useEffect(() => {
    const error = Object.values(errors).findIndex(err => err)

    setButton((button) => ({
      ...button,
      isDisabled: !error
    }))

  }, [errors])

  if (!user) return <PageLoaderComponent />;

  return (
    <Template>
      <S.Grid className="grid medium-space">
        <div className="account-hub-content">
          <div className="section-header">
            <div className="section-header-info">
              <p className="section-pretitle">Novo usuário</p>

              <h2 className="section-title">Informação de usuário</h2>
            </div>
          </div>

          <div className="grid-column">

            <div className="widget-box">
              <p className="widget-box-title">Sobre o novo usuário</p>

              <div className="widget-box-content">
                <form className="form" action="" method="POST" onSubmit={handleUserCreate}>
                  <div className="form-row">
                    <div className="form-item">
                      <RoleSelectorComponent value={user.roleId} onChange={handleRoleChange} />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-item">
                      <MultiSelect parentList={user.parentList} onChange={(value) => setUser({ ...user, parentList: value })} />
                    </div>
                  </div>

                  <div className="form-row split">
                    <div className="form-item">
                      <InputText name="name" label="Nome Completo" id="name" value={user.name} onChange={(value) => setUser({ ...user, name: value })} required />
                    </div>

                    <div className="form-item">
                      <InputText name="email" label="Email Corporativo" id="email" value={user.email} onChange={(value) => setUser({ ...user, email: value })} />
                    </div>
                  </div>

                  <div className="form-row split">
                    <div className="form-item">
                      <InputText name="cellphone" label="Telefone Corporativo" id="cellphone" value={user.cellphone} onChange={(value) => setUser({ ...user, cellphone: MaskPhone(value) })} maxLength="15" />
                    </div>
                    <div className="form-item">
                      <InputText name="document" label="CPF/CNPJ" id="document" value={user.document} onChange={(value) => setUser({ ...user, document: MaskDocument(value) })} maxLength="18" />
                    </div>
                  </div>

                  <div className="form-row split">
                    <div className="form-item">
                      <CargoComponent name="cargo" label="Cargo" id="cargo" value={user.cargo} onChange={(value) => setUser({ ...user, cargo: value })} />
                    </div>
                  </div>

                  <SpeciesComponentTabs value={user.species} onChange={handleSpeciesChange} onChangeError={handleSetErrors} />

                  {hasDistributor && <>
                    <p className="widget-box-title">Escolha o distribuidor</p>

                    <div className="widget-box-content">
                      <div className="form-row split">
                        <div className="form-item">
                          <InputText name="name" label="Nome" id="name" value={distributor.name} onChange={(value) => setDistributor({ ...distributor, name: value })} required />
                        </div>

                        <div className="form-item">
                          <InputText name="email" label="CNPJ" id="email" value={distributor.email} onChange={(value) => setDistributor({ ...distributor, email: value })} />
                        </div>
                      </div>
                    </div>
                  </>
                  }

                  <div className="form-row split">
                    <div className="form-item">
                      <S.SubmitButton className="button primary add-field-button" type="submit" disabled={button.isDisabled}>{button.name}</S.SubmitButton>
                    </div>
                  </div>

                </form>

                <div className="widget-box-content">
                </div>
              </div>
            </div>

          </div>
        </div>
      </S.Grid>
    </Template >
  );
}
